import React from 'react'
import defaultImage from 'images/placeholders/slide.jpg'
import pdfLogo from 'images/pdf-logo.png'
import bg from 'images/personas/bg-did-you-know.jpg'
import LimitedViewText from './LimitedViewText'

const DidYouKnow  = ({
  brandPhotos,
  countries,
  creationDate,
  limitedView,
  trends
}) => {
  const content = (
    <React.Fragment>
      <div className="flex-auto p4 sm-p0">
        <div className="flex flex-center flex-wrap mxn2">
          <div className="col-6 px2 sm-col-12 sm-mb3">
            <p className="persona-title">Did you know?</p>
          </div>

          <div className="col-6 px2 sm-col-12 sm-mb3">
            {
              !limitedView
              && (
                <ul className="h2 x-lg-h3">
                  <li>
                    The top trending in specified location on {new Date(creationDate).toLocaleDateString('en-EN', { year: 'numeric', month: 'long', day: '2-digit' })} are

                    {trends.map((trend, index) => (<span> {trend}{trends.length !== index + 1 ? ',' : '.'}</span>))}
                  </li>
                </ul>
              )
              || <LimitedViewText />
            }
          </div>
        </div>
      </div>

      <div>
        <img alt="" className="block" src={bg} />
      </div>
    </React.Fragment>
  )

  return (
    <React.Fragment>
      <section className="section" data-anchor="did-you-know">
        <div className="slider-box slider-box--pdf-p0 bg-white box-shadow-box flex flex-wrap">
          <div className="col-12 flex flex-column">
            {content}
          </div>
        </div>
      </section>
    </React.Fragment>
  )
}

export default DidYouKnow
